"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGradeScore = exports.getScoreMapFromSlug = exports.calcScoreColor = exports.getScoringRating = exports.getScoringModel = exports.isGrade = void 0;
const bureaus_1 = require("./bureaus");
const case_insensitive_includes_1 = require("./case-insensitive-includes");
const scoreRatingFallback = {
    minScore: 0,
    maxPoor: 50,
    maxFair: 80,
    maxGood: 100,
};
const isGrade = (value) => {
    return typeof value === 'string';
};
exports.isGrade = isGrade;
const getScoringModelData = (identifier, type) => {
    var _a;
    const bureau = typeof identifier === 'object' ? identifier : (0, bureaus_1.getBureau)(identifier);
    const scoreModels = (_a = bureau === null || bureau === void 0 ? void 0 : bureau.scoreModels) !== null && _a !== void 0 ? _a : bureaus_1.bureaus.map((b) => b.scoreModels).reduce((acc, val) => [...acc, ...val], []);
    if (type) {
        return scoreModels.find((scoreModel) => { var _a; return (0, case_insensitive_includes_1.caseInsensitiveIncludes)([scoreModel.type, scoreModel.reportableType, ...((_a = scoreModel.aliases) !== null && _a !== void 0 ? _a : [])], type); });
    }
    return scoreModels.length === 1 ? scoreModels[0] : undefined;
};
const getScoringModel = (identifier, type) => {
    const scoringModelData = getScoringModelData(identifier, type);
    if (scoringModelData === undefined) {
        return undefined;
    }
    // To get around "Object is possibly 'undefined'" errors
    const definedScoringModelData = scoringModelData;
    return Object.assign(Object.assign({}, definedScoringModelData), { get bureau() {
            return (0, bureaus_1.getBureau)(definedScoringModelData.bureauIdentifier);
        },
        get scoreDisplayName() {
            var _a;
            return `${(_a = (0, bureaus_1.getBureau)(definedScoringModelData.bureauIdentifier)) === null || _a === void 0 ? void 0 : _a.displayName} ${definedScoringModelData.reportableType}`;
        },
        get displayNameWithType() {
            const bureau = (0, bureaus_1.getBureau)(definedScoringModelData.bureauIdentifier);
            const suffix = definedScoringModelData.type === 'Personal' ? 'Personal' : bureau.slug === 'xpn' ? 'Business' : '';
            const chunks = [bureau.displayName, definedScoringModelData.shortReportableType, suffix];
            return chunks.filter((exists) => exists).join(' ');
        } });
};
exports.getScoringModel = getScoringModel;
const getScoringRating = (identifier, reportableType) => {
    var _a, _b;
    return (_b = (_a = (0, exports.getScoringModel)(identifier, reportableType)) === null || _a === void 0 ? void 0 : _a.scores) !== null && _b !== void 0 ? _b : scoreRatingFallback;
};
exports.getScoringRating = getScoringRating;
const calcScoreColor = ({ identifier = 'xpn', score = 0, reportableType = 'Business', }) => {
    var _a, _b;
    const scoringModel = (0, exports.getScoringModel)(identifier, reportableType);
    if (!scoringModel) {
        return 'poor';
    }
    if ((0, exports.isGrade)(score)) {
        return (_b = (_a = scoringModel.gradeColor) === null || _a === void 0 ? void 0 : _a[score]) !== null && _b !== void 0 ? _b : 'poor';
    }
    const { minScore, maxPoor, maxFair } = scoringModel.scores;
    if (score > maxFair) {
        return 'good';
    }
    else if (score > maxPoor) {
        return 'fair';
    }
    else if (score > minScore) {
        return 'poor';
    }
    return 'poor';
};
exports.calcScoreColor = calcScoreColor;
const getScoreMapFromSlug = ({ bureau = 'xpn', reportableType = 'Business', score = 0, }) => {
    var _a;
    const scoringModel = (0, exports.getScoringModel)(bureau, reportableType);
    return (_a = ((0, exports.isGrade)(score) ? scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.grades : scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.scores)) !== null && _a !== void 0 ? _a : scoreRatingFallback;
};
exports.getScoreMapFromSlug = getScoreMapFromSlug;
const getGradeScore = ({ bureau, reportableType = 'Business', score, }) => {
    var _a, _b;
    const scoringModel = (0, exports.getScoringModel)(bureau, reportableType);
    return (_b = (_a = scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.grades) === null || _a === void 0 ? void 0 : _a[score]) !== null && _b !== void 0 ? _b : 0;
};
exports.getGradeScore = getGradeScore;
//# sourceMappingURL=scoring-model.js.map